import { render, staticRenderFns } from "./RegistrationReport.vue?vue&type=template&id=ddf3fbb8&"
import script from "./RegistrationReport.vue?vue&type=script&lang=js&"
export * from "./RegistrationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports